import store from "../store";
import {currencyFormat} from "../functions";
import Vue from "vue";

export default {
    data() {
        return {
            addingToCart: false,
            currencyFormat
        };
    },
    methods: {
        productUrl(product) {
            return route('products.show', product.slug);
        },

        hasBaseImage(product) {
            return product.base_image !== null && product.base_image !== '';
        },

        baseImage(product) {
            if (this.hasBaseImage(product)) {
              return product.base_image
            }

            return `${window.Trillion.baseUrl}/themes/storefront/public/images/image-placeholder.png`;
        },

        addToCart(product, event) {
            event.preventDefault()
            event.stopImmediatePropagation()
            $.ajax({
                method: "POST",
                url: route("cart.items.store", {
                    product_id: product.id,
                    qty: 1,
                }),
            })
                .then((cart) => {
                    store.updateCart(cart);
                    this.$successNotify("Product has been added to your cart")
                    // Check here for old add cart
                })
                .catch((xhr) => {
                    this.$errorNotify(xhr.responseJSON.message)
                })
                .always(() => {
                    this.addingToCart = false;
                });
        },
        productPrice(product) {
            return "$" + currencyFormat(product.selling_price.amount)
        },
        productQty(product) {
            return "Each (" + (currencyFormat(product.qty_in_stock ?? 0,0,0)) + " Available)"
        }
    },
};
